import Link from '@mui/material/Link';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as ReactRouterLink } from 'react-router-dom';

const eyeAbleUrlMapping = {
    '/arbeitsplatzausstattung-barrierefreiheit/':
        'https://eye-able.com/en/workplace-equipment-accessibility/',
    '/wordpress-plugin-installation/': 'https://eye-able.com/en/wordpress-plugin-installation/',
    '/installation-der-software/': 'https://eye-able.com/en/installation-of-the-software/'
};

const LinkBehavior = forwardRef(function LinkBehaviorRef(props, ref) {
    return <ReactRouterLink ref={ref} {...props} />;
});

const RouterLink = forwardRef(function RouterLinkRef(props, ref) {
    const { i18n } = useTranslation();

    const { external, sx, ...rest } = props;

    const isExternal = external || !!props?.to?.startsWith('http');

    if (isExternal) {
        if (props.to?.startsWith('https://eye-able.com')) {
            const lng = i18n.resolvedLanguage;

            if (lng !== 'de') {
                let url = new URL(props.to);
                let path = url.pathname; // eg '/wcag-checker/'

                if (path) {
                    rest.to =
                        eyeAbleUrlMapping[path] ||
                        `https://eye-able.com/${i18n.resolvedLanguage}${path}`;
                }
            }
        }
    }

    const linkProps = {
        fontSize: 'inherit',
        underline: 'hover',
        role: undefined,
        target: isExternal ? '_blank' : '_self',
        rel: 'noopener noreferrer',
        color: isExternal ? '#003fab' : 'inherit',
        sx: theme => ({
            'textDecorationColor': 'inherit !important',
            '&:focus:not(.MuiButtonBase-root)': {
                outline: `3px solid ${theme.palette.secondary.dark}`,
                outlineOffset: '2px'
            },
            '&:hover:not(.MuiButtonBase-root)': isExternal
                ? {
                      filter: 'brightness(1.25)'
                  }
                : {},
            ...sx
        }),
        ...rest
    };

    return (
        <Link {...linkProps} component={LinkBehavior} ref={ref}>
            {linkProps.children}
        </Link>
    );
});

export default RouterLink;
